module.exports = __webpack_public_path__ + "static/media/ct-10.764cc965.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/ct-10.png
// module id = 86
// module chunks = 0